import React from 'react';
import styles from './StudentActivityWidget.module.css';
import MLButton from '../../../components/MLButton';

const StudentActivityWidget = ({
  studentsWithoutActivity,
  daysThreshold = 7,
  onViewClick,
}) => {
  const studentCount = studentsWithoutActivity?.length ?? 0;
  const formattedStudents = studentCount === 1 ? 'student' : 'students';
  return (
    <div className={styles.container} data-test-id="activity_summary_container">
      <div
        className={styles.title}
        data-test-id="inactive_students_alert_title"
      >
        Inactive Students
      </div>
      <div className={styles.studentCount}>
        {studentCount} {formattedStudents}
      </div>
      <div className={styles.launchInfo}>
        Have not launched an activity in the last {daysThreshold} days
      </div>
      <div className={styles.viewStudentsBtnContainer}>
        <MLButton
          className={styles.viewStudentsBtn}
          onClick={onViewClick}
          btnType="secondary"
          btnText="View Student Activity"
          testId="inactive_alert_view_student_activity_btn"
        />
      </div>
    </div>
  );
};

export default StudentActivityWidget;
